export default __webpack_public_path__ + "d245a4955352cee187a6de6f8694d608.jpg";